/**
 * Arrow controls for the custom recommendations slider.
 *
 * The track is injected after page load by product-recommendations.js (fetch +
 * hydration morph), so nothing here may assume the DOM exists at parse time:
 *  - clicks use document-level delegation
 *  - scroll is observed in the capture phase, since scroll events don't bubble
 *  - a MutationObserver sets the initial arrow state on injected tracks
 *
 * Loading this file more than once is harmless — the flag guards re-binding.
 */
(function () {
  if (window.__cprsSliderBound) return;
  window.__cprsSliderBound = true;

  /** Distance to move per arrow click: one card plus one gap. */
  function stepFor(track) {
    var item = track.querySelector('.cprs__item');
    if (!item) return track.clientWidth;
    var gap = parseInt(getComputedStyle(track).columnGap, 10);
    if (isNaN(gap)) gap = 0;
    return item.offsetWidth + gap;
  }

  /** Hide an arrow when the track can't move further that way. */
  function updateArrows(track) {
    var viewport = track.closest('[data-cprs-slider]');
    if (!viewport) return;

    var prev = viewport.querySelector('.cprs__nav--prev');
    var next = viewport.querySelector('.cprs__nav--next');

    // 1px tolerance — fractional widths mean scrollLeft rarely hits the exact max.
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    // Nothing to scroll at all: hide both.
    var overflows = track.scrollWidth > track.clientWidth + 1;

    if (prev) prev.hidden = !overflows || atStart;
    if (next) next.hidden = !overflows || atEnd;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cprs__nav');
    if (!button) return;

    var viewport = button.closest('[data-cprs-slider]');
    var track = viewport && viewport.querySelector('[data-cprs-track]');
    if (!track) return;

    event.preventDefault();

    var direction = button.getAttribute('data-direction') === 'next' ? 1 : -1;
    track.scrollBy({ left: direction * stepFor(track), behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (track && track.nodeType === 1 && track.hasAttribute && track.hasAttribute('data-cprs-track')) {
        updateArrows(track);
      }
    },
    true
  );

  function initAll() {
    document.querySelectorAll('[data-cprs-track]').forEach(function (track) {
      if (track.dataset.cprsReady === 'true') return;
      track.dataset.cprsReady = 'true';
      updateArrows(track);
    });
  }

  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-cprs-track]').forEach(updateArrows);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
